import { Country } from 'country-state-city';
import { registerLocale, getNames } from 'i18n-iso-countries';
import tr from 'i18n-iso-countries/langs/tr.json';
import en from 'i18n-iso-countries/langs/en.json';
import ja from 'i18n-iso-countries/langs/ja.json';

// Register locales
registerLocale(tr);
registerLocale(en);
registerLocale(ja);

/**
 * Get translated country name using i18n-iso-countries
 * @param {string} countryCode - ISO country code
 * @param {string} language - Language code (en, tr)
 * @returns {string} - Translated country name
 */
export const getTranslatedCountryName = (countryCode, language = 'en') => {
    try {
        const names = getNames(language);
        return names[countryCode] || countryCode;
    } catch (error) {
        console.warn(`Translation not found for country ${countryCode} in language ${language}`);
        return countryCode;
    }
};

/**
 * Get all countries with translated names using i18n-iso-countries
 * @param {string} language - Language code (en, tr)
 * @returns {Array} - Array of country objects with translated names
 */
export const getTranslatedCountries = (language = 'en') => {
    try {
        const names = getNames(language);
        return Country.getAllCountries().map(country => ({
            label: names[country.isoCode] || country.name,
            value: country.isoCode,
            originalName: country.name
        }));
    } catch (error) {
        console.warn(`Failed to get country names for language ${language}, falling back to English`);
        // Fallback to English
        const names = getNames('en');
        return Country.getAllCountries().map(country => ({
            label: names[country.isoCode] || country.name,
            value: country.isoCode,
            originalName: country.name
        }));
    }
};
